import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { formatPSETemperature, PSE_BLOCK_TYPES } from "../../../utils/productionStepExecution"
import PSEToggleFormButtons from "./alerts/PSEToggleFormButtons"
import { updatePSEMachinesBatchTemperatureForAlerts } from "../../../actions/ProductionSteps/ProductionStepExecutions"
import PSESection from "./section/PSESection"
import ProductionStepExecutionMachinesForm from "../productionStepExecutionInProgressCases/ProductionStepExecutionMachinesForm"

const PSECookingRecap = ({
	pseId,
	machinesBatch = [],
	visible = true,
	isFromAlertsPage = false
}) => {
	const [isEdition, setIsEdition] = useState(false)
	const [machinesBatchValues, setMachinesBatchValues] = useState({})

	const dispatch = useDispatch()

	useEffect(() => {
		if (!isEdition) return
		machinesBatch.forEach((machineBatch, index) => {
			setMachinesBatchValues((prevValues) => ({
				...prevValues,
				[index]: {
					temperature: formatPSETemperature(machineBatch, "COOKING")
				}
			}))
		})
	}, [machinesBatch])

	if (!visible) {
		return null
	}

	const openIsEdition = () => setIsEdition(true)
	const closeIsEdition = () => {
		setIsEdition(false)
		setMachinesBatchValues({})
	}

	const handleChangeTemperatures = (index, newValue) => {
		setMachinesBatchValues((prevValues) => ({
			...prevValues,
			[index]: {
				...prevValues[index],
				...newValue
			}
		}))
	}

	const handleSubmit = async () => {
		if (!isFromAlertsPage) return
		if (!pseId) return

		await dispatch(updatePSEMachinesBatchTemperatureForAlerts(pseId, machinesBatchValues))
		closeIsEdition()
	}

	return (
		<PSESection
			sectionType={PSE_BLOCK_TYPES.COOKING}
			title="Cuisson"
			renderTopRight={() => (
				<>
					{isFromAlertsPage && (
						<div className="flexRow justifyEnd center">
							<PSEToggleFormButtons
								isEdition={isEdition}
								onSubmit={handleSubmit}
								onClose={closeIsEdition}
								onOpen={openIsEdition}
							/>
						</div>
					)}
				</>
			)}
		>
			<ProductionStepExecutionMachinesForm
				mode={PSE_BLOCK_TYPES.COOKING}
				machinesBatch={machinesBatch}
				handleChangeTemperatures={isEdition ? (index, newValue) => {
					handleChangeTemperatures(index, newValue)
				} : null
				}
			/>
		</PSESection>
	)

}

export default PSECookingRecap